import { render, staticRenderFns } from "./AcademicReferencesSuperior.vue?vue&type=template&id=55aad2d2&"
import script from "./AcademicReferencesSuperior.vue?vue&type=script&lang=js&"
export * from "./AcademicReferencesSuperior.vue?vue&type=script&lang=js&"
import style0 from "./AcademicReferencesSuperior.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports